import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';

export const ErrorBoundary = ({ children }: { children: React.ReactNode }) => (
  <RpErrorBoundary>{children}</RpErrorBoundary>
);
